import ContainerCustom from "../../../Components/ContainerCustom";
import Table from "../../../Components/Table/Table";
import TableButton from "../../../Components/Buttons/TableButton";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { useState, useEffect } from "react";
import ModalSimple from "../../../Components/ModalSimple";
import WithdrawModal from "../../Transactions/Components/WithdrawModal";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";

export default function ChallengeList() {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [activeFilter, setActiveFilter] = useState(categories.map(() => true));
  const [challenges, setChallenges] = useState([]);
  const fetchChallengesData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      setChallenges(data);
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  const fetchCategoriesData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/categories/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/categories/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Categories Data:", data);
      setCategories(data.categories);
    } catch (error) {
      console.error("Error fetching categories data:", error);
    }
  };
  useEffect(() => {
    fetchCategoriesData();
    fetchChallengesData();
  }, []);
  useEffect(() => {
    setActiveFilter(categories.map(() => true));
  }, [categories]);
  const activeCategories = categories.filter((_, index) => activeFilter[index]);
  return (
    <>
      <ContainerCustom
        header="لیست چالش‌ها"
        headSVG="archive"
        colorfulFilterOptions={categories.map((category) => ({
          SVGName: "star",
          text: category,
          className: "w-24",
          color: "blue",
        }))}
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
        filter={false}
        sort={false}
        search={false}
      >
        <Table
          columns={[
            { key: "uuid", label: "کد چالش" },
            { key: "type", label: "نوع چالش" },
            {
              key: "class",
              label: "دسته چالش",
              render: (value, row) => {
                return (
                  <StatusColorful
                    SVGName="star"
                    text={row.class}
                    className="w-24"
                    color="blue"
                  />
                );
              },
            },
            { key: "name", label: "نام چالش" },
            { key: "price", label: "قیمت چالش" },
            { key: "discountPercent", label: "درصد تخفیف" },
            { key: "discountPrice", label: "قیمت پس از تخفیف" },
            {
              key: "detail",
              label: "جزئیات",
              render: (value, row) => (
                <TableButton
                  text="مشاهده"
                  href=""
                  onClick={() => {
                    navigate(`/challenges/${row.uuid}/challenge-info`);
                  }}
                  className="!py-1 !px-2 !rounded-md bg-zi-bg1-light dark:bg-zi-bg1-dark text-zi-text-light dark:text-zi-text-dark hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark"
                />
              ),
            },
          ]}
          data={
            challenges
              ? challenges
                  .filter((item) => activeCategories.includes(item.category))
                  .map((item) => ({
                    uuid: item.id,
                    type: item.challenge_type === "real" ? "واقعی" : "تمرینی",
                    class: item.category,
                    name: item.name,
                    price: `$${item.cost}`,
                    discountPercent: item.discount_percent
                      ? item.discount_percent
                      : "-",
                    discountPrice: item.discount_cost
                      ? `$${item.discount_cost}`
                      : `-`,
                    detail: "",
                  }))
              : []
          }
        />
      </ContainerCustom>
    </>
  );
}
